/* eslint-disable i18next/no-literal-string */
import { isObject, SimpleTradeCompanyLeadListItem, useApiTradeV1TradeCompanyLeadsList } from 'api';
import { useState } from 'react';
import { AutocompleteProps } from 'ui';

import { AutocompleteField } from '../AutocompleteField/AutocompleteField';

type Props = Omit<AutocompleteProps<SimpleTradeCompanyLeadListItem>, 'options' | 'defaultValue'> & {
  name: string;
  label?: string;
  onSelectOption?: (value: SimpleTradeCompanyLeadListItem) => void;
  defaultValue?: SimpleTradeCompanyLeadListItem['id'];
};

export const TradeCompanyLeadAutocomplete = ({
  name,
  label = 'Select company from HubSpot',
  onSelectOption,
  defaultValue,
  ...rest
}: Props) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiTradeV1TradeCompanyLeadsList({
    search: query,
  });

  return (
    <AutocompleteField<SimpleTradeCompanyLeadListItem>
      options={data?.results || []}
      loading={isLoading}
      {...rest}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.name && option?.hs_object_id) {
          return `${option.name} (${option.hs_object_id})`;
        }
        return '';
      }}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      name={name}
      label={label}
      placeholder="Type to search"
      valueField="id"
      onSelectOption={onSelectOption}
      data-testid="trade-company-lead-autocomplete"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
    />
  );
};
